module.exports = __webpack_public_path__ + "static/media/sad-tear.6c7879a2.svg";